import script from "./PaymentReceipt.vue?vue&type=script&setup=true&lang=js"
export * from "./PaymentReceipt.vue?vue&type=script&setup=true&lang=js"

import "./PaymentReceipt.vue?vue&type=style&index=0&id=50438b7e&lang=scss&scoped=true"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-50438b7e"]])

export default __exports__